import React, { useState, useEffect } from "react";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardHeader, CardTitle, CardBody, ModalHeader } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useAuth0 } from "react-auth0-spa";
import UserList from "./UserList";
import ReactTable from "components/ReactTable/ReactTable.tsx";
import SoftphoneV1 from "components/Phone/V1/SoftphoneV1";
import AgentService from "core/api/AgentService";
import { PhoneSelectorInputComponent } from "./PhoneSelectorInputComponent";
import { AddressSelectorInputComponent } from "./AddressSelectorInputComponent";


export default function CallCenter() {
    const [currentCalls, setCurrentCalls] = useState([])
    const [callTaken, setCallTaken] = useState(false);
    const [createReport, setCreateReport] = useState(false);
    const [elevatorID, setElevatorID] = useState(null);
    const [buildingID, setBuildingID] = useState(null);
    const [unknownPhoneNumber, setUnknownPhoneNumber] = useState(null);
    const [unknownBuildingAddress, setUnknownBuildingAddress] = useState(null);

    const { user } = useAuth0();
    const history = useHistory();


    const takeCall = async (id, status) => {
        if (status == "answered") {
            openCallReport(id)
        } else {
            const callOpened = await AgentService.takeCall({ Id: id, UserEmail: user.email })
            if (callOpened) {
                openCallReport(id)
            } else {
                setCallTaken(true)
            }
        }
    }

    const openCallReport = (id) => {
        // window.open(`/admin/call/${id}`, "_blank")
        history.push(`call/${id}`)
    }

    // const test = async () => {
    //     const results = await AgentService.testTwillio({ CallStatus: "ringing", From: "+19293556439", callSid: "CA7df79cf9fb63b2428fb3965b30fd1234" })
    //     console.log(results)
    // }

    const createNewReport = async () => {
        const newReport = await AgentService.manuallyAddCall({ ElevatorID: elevatorID, ElevatorPhoneNumber: unknownPhoneNumber, BuildingID: buildingID, BuildingAddress: unknownBuildingAddress, UserEmail: user.email, Status: "answered", DateTimeAnswered: new Date(), dateTimeReceived: new Date() })

        if (newReport.id) {
            openCallReport(newReport.id)
        }
    }


    useEffect(() => {
        async function fetchData() {
            const currentCalls = await AgentService.getCurrentCalls()
            setCurrentCalls(currentCalls.model)

        }

        fetchData();
        const interval = setInterval(() => {
            fetchData()
        }, 30000)

        return () => { clearInterval(interval) }
    }, []) 


    return (
        <>
            <PanelHeader content={
                <div className="header text-center">
                    <h2 className="title">
                        Call Center
                    </h2>
                </div>}
            />
            <div className="content" style={{ paddingTop: 30 }}>

                {/* <Button onClick={test} color="primary">TEST</Button> */}

             
                <Modal isOpen={callTaken} centered={true} >
                    <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                        <div className="title">This Call Was Taken</div>
                        <i className="las la-phone-volume" style={{ fontSize: 50 }}></i>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => setCallTaken(false)} style={{ margin: "auto", display: "block" }} >OK</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={createReport} centered={true} >
                    <ModalHeader style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
                        <div className="title" >Select an Elevator</div>
                    </ModalHeader>
                    <ModalBody style={{ justifyContent: "center", alignContent: "center", marginBottom: 15, display: "flex", flexDirection: "column", gap: "25px" }} >
                        <div>
                            Phone Number: {unknownPhoneNumber != null && `(Using Unknown Number)`}
                            <PhoneSelectorInputComponent value={elevatorID} setValue={setElevatorID} setUnknownPhoneNumber={setUnknownPhoneNumber} />
                        </div>

                        {unknownPhoneNumber != null &&
                            <div>
                                Address: {unknownBuildingAddress != null && `(Using Unknown Address)`}
                                <AddressSelectorInputComponent value={buildingID} setValue={setBuildingID} setUnknownBuildingAddress={setUnknownBuildingAddress} />
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter >
                        <Button color="primary" onClick={() => { setCreateReport(false); setElevatorID(null) }} style={{ margin: "auto", display: "block" }} >Cancel</Button>
                        <Button color="primary" onClick={() => { createNewReport() }} style={{ margin: "auto", display: "block" }} disabled={(elevatorID == null && unknownPhoneNumber == null) || (unknownPhoneNumber != null && unknownBuildingAddress == null && buildingID == null)}>Create Report</Button>
                    </ModalFooter>
                </Modal>

                <SoftphoneV1 />
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Current Calls</CardTitle>
                                <Button onClick={() => { setCreateReport(true) }} color="primary">New Report</Button>
                            </CardHeader>
                            <CardBody>

                                <ReactTable
                                    data={currentCalls}
                                    columns={[

                                        {
                                            header: "Phone Number",
                                            accessorKey: "elevatorPhoneNumber",
                                        },
                                        {
                                            header: "Date Received",
                                            accessorKey: "dateTimeReceived",
                                            accessorFn: row => { return new Date(row.dateTimeReceived) },
                                            filterFn: 'filterDate',
                                        },
                                        {
                                            header: "Elevator",
                                            accessorKey: "elevatorName",
                                            accessorFn: row => { return row.elevatorName ?? "Unknown" },
                                        },
                                        {
                                            header: "Elevator Company",
                                            accessorKey: "elevatorCompanyName",
                                        },
                                        {
                                            header: "Customer",
                                            accessorKey: "customerName",
                                            accessorFn: row => { return row.customerName ?? "Unknown" },
                                        },
                                        {
                                            header: "Building",
                                            accessorKey: "buildingName",
                                            accessorFn: row => { return row.buildingName ?? "Unknown" },
                                        },
                                        {
                                            id: "takeCall",
                                            cell: ({ row }) => (
                                                <>
                                                    {row.original.status == "answered" && row.original.userEmail != user.email ?
                                                        <div>
                                                            <div>Call Taken By :</div>
                                                            <div>{row.original.userEmail}</div>
                                                        </div>
                                                        : 

                                                        <Button color="primary" style={{ margin: 0 }}
                                                            onClick={(event) => { takeCall(row.original.id, row.original.status); event.stopPropagation() }}
                                                        >
                                                            {row.original.status == "answered" ? "Continue Call" : "Take Call"}
                                                        </Button>
                                                    }

                                                </>
                                            ),

                                        }

                                    ]}
                                    fetchData={() => { }}
                                    defaultPageSize={100}
                                    getTrProps={() => { }}
                                />

                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <UserList title="Agents Online" type="active" />
            </div>
        </>


    )
}

